import { useEffect, useState } from "react";
import "./CourseCard1.css";
import fallback_img from "./img/fallback_img.jpg"
import loading_img from "./img/loadingImg.jpg"

import placeholderImg from "../UI/Placeholder/thumbnailPlaceholder.png"
import { ChevronDown, ChevronRight, ChevronsLeftRightEllipsis, Heart, LayoutDashboard, Play, ShoppingCart, StepBack, StepForward, X } from "lucide-react";
import CourseCardAllInfoPage from "./CourseCardAllInfoPage";
import YoutubeVideoPlayerWebUI from "../UI/YoutubeVideoPlayerWebUI";
const CourseCard1PopUp= ({item,setPopUpItem})=>{

 const [videoPopUp, setVideoPopUp] = useState(false);
      const [activeTab, setActiveTab] = useState("CourseInfo");
    const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 console.log(item)
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={``}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={``}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={``}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={``}
      />
    </div>
  );
};
const [currentI, setCurrentI] = useState(0);
const totalSlides = item?.videoLinks?item?.videoLinks.length:0;
 function getYouTubeThumbnail(input) {
    try {
      // Extract video token
      const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      let videoId;
  
      if (input.startsWith("<iframe")) {
        const srcMatch = input.match(/src="([^"]+)"/);
        if (!srcMatch) {
          throw new Error("No src attribute found in the iframe tag");
        }
        const srcUrl = srcMatch[1];
        const match = srcUrl.match(regex);
        videoId = match ? match[1] : null;
      } else {
        const match = input.match(regex);
        videoId = match ? match[1] : null;
      }
  
      if (!videoId) {
        throw new Error("No video token found");
      }
  
      // Return thumbnail URLs
      return {
        default: `https://img.youtube.com/vi/${videoId}/default.jpg`,
        highQuality: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
        mediumQuality: `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
        standardDefinition: `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
        maxResolution: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
      };
    } catch (error) {
      console.error("Error extracting thumbnail:", error.message);
      return null;
    }
  }
return(<>
 <div     style={{zIndex:99999,cursor:"pointer"}} onClick={()=>setPopUpItem()} className="CourseCard1PopUpOpacity"> </div>
     
<div className="CourseCard1PopUp">
<div className="courseCard1OuterPopUp" >
    {item?.typeLabel?<div className="courseCardAllTypeLabel">{JSON.parse(item?.typeLabel)?.post_title}</div>:""}
  {item?.typeLabel?<div className="courseCardAllStatusLabel">{JSON.parse(item?.statusLabel)?.post_title}</div>:""}

    
    <div style={{width:"40px",height:"40px",cursor:"pointer",position:"absolute",
           borderRadius:"50%",right:"0px",margin:"1px",
         background:"#958FDA",zIndex:999999}} onClick={()=>setPopUpItem()}   >
           <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
           <div style={{position:"relative"}}>
   <ImageFallFB  itemOuter={{}}
                  boxShadow={``}
                  src={"https://picsum.photos/400/550?random=50"+item?.ID}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={
                    2/1.1
                  }
                  borderRadius={
                    {
                      value: 10,
                      resolution: "%",
                    }
                  }
                /> 
                
               {item?.videoLinks? <div style={{display:"flex",justifyContent:"center",}}>
      <div onClick={()=>{setVideoPopUp(true) 
      }}   className={`playBtnCourseCardAllPopUpVideo`} style={{position:"absolute",zIndex:"9999999", alignItems:"center",cursor:"pointer"}} > 
      <div className={`playBtnCourseCardAllPopUpVideoInner`} ></div>
       <Play strokeWidth={3}  size={45} style={{margin:"4px"}}  color="#fff"/>
          </div></div>:""}
          
          
          
          </div>
                 <div className="courseCard1MiddleButtons">
                     <div className="courseCard1MiddleButtons"><div className="courseCardAllBuyNowBtn">Buy Now</div>
                   <div className="courseCard1MiddleButtonsItem courseCard1MiddleButtonsItem2">
                     <Heart strokeWidth={1.75} size={20} color={"#777777"} /> </div> 
                     <div className="courseCard1MiddleButtonsItem courseCard1MiddleButtonsItem3">
                     <ShoppingCart strokeWidth={1.75} size={20} color={"#777777"} /> </div> </div> 

                  
                     </div>
                     <div className="courseCard1MiddleButtons">
                           <div className="courseCard1MiddleButtons">
             {item?.languageLabel? <div className="courseCardAllLanguageLabel">{JSON.parse(item?.languageLabel)?.post_title}</div>:""}
              {item?.difficultyLabel?<div className="courseCardAllDifficultyLabel">{JSON.parse(item?.difficultyLabel)?.post_title}</div>:""}
              
              </div>      <div className="courseCard1MiddleButtons">
            
              <div className="courseCardAllTryFreeBtn">Try Free</div>
              
              </div>  </div>
                    
<div className="theme1  CoursePopUpCardTitle  "  style={{
                       borderRadius:"25px",marginTop:"10px",fontWeight:"900",color:"#222"}}>
                       
                        {item?.productName}
                       </div> 


                       {/* <div className="coursePopUpInfoTabs">
             <div onClick={()=>{setActiveTab("CourseInfo")}} className={`coursePopUpInfoTabsInn ${activeTab=="CourseInfo"?"coursePopUpInfoTabsInnActive":""}`} > Course Information </div>
             <div  onClick={()=>{setActiveTab("SubCourses")}} className={`coursePopUpInfoTabsInn ${activeTab=="SubCourses"?"coursePopUpInfoTabsInnActive":""}`}> Sub-Courses </div>  </div>
          */}
                    {activeTab=="CourseInfo"?<> <CourseCardAllInfoPage  item={item}  />     </>:""}
                       
                      
                       <div className="courseCard1OuterPopUp" >
                   {/* {activeTab=="SubCourses"?<><ShowSubCoursesInCourse item={item} appItem={appItem} /></>:""} */}
                   
</div>
                       
</div></div>
{videoPopUp?<>
       <div     style={{zIndex:99,cursor:"pointer"}} onClick={()=>setVideoPopUp(false)} className={`videoPlayerPopUpBackDrop`}> </div>
        <div   className={`videoPlayerPopUpMain`} style={{borderRadius: '0px',overflowY:"auto"}}> 
  <div style={{position:"relative"}}>
    <div  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"0px",margin:"10px",position:"absolute",
      background:`#222222`,zIndex:99999999999999}} onClick={()=>{setVideoPopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div>
    </div> 
      {item?.videoLinks?JSON.parse(item?.videoLinks)?.map((itemVideo,index)=>(
<>{index==currentI?
<YoutubeVideoPlayerWebUI  videoSettings={{
                          
                            videoPlayButton:{
                                     playButtonBorderRadius:{value:0,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(144, 202, 249,1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}} ,
                                     playIconColor:{normal:{},hover:{}}  ,
                                    
                                     onClickActionArray:[{title:"Play Video",value:"playVideo"},
                                     {title:"Pop Up Video",value:"popUpVideo"},{title:"Open Lead Form",value:"popUpLeadForm"}],
                                    // popUpLeadFormBeforePlay- set status in cookie
                                     onClickAction:"playVideo",// 
                                     popUpLeadForm:{
                                     delay:10,sendLeadInfoToEmail:{email:""},
                                     showFields:{name:true,email:true,mobile:true,city:false,
                                    //  custom:[{fieldName:"Any Name",status:false}]
                                    }
                                      }, 
                                     popUpVideo:{ showOnlyPlayButton:false },
                                    
                                          }
                                       }} videoId={itemVideo?.youtubeLink} minHeight={400} maxHeight={400}/>:""}
   </>
      )):""}  <div className="videos-Outer-wrapper"  >
  
          
    
  {item?.videoLinks?JSON.parse(item?.videoLinks).map((itemInner, i) => {
      
      return (
        <div className="" key={i}
          onClick={() => setCurrentI(i)}
          style={{display:"flex",justifyContent:"left",gap:"10px",flexWrap:"nowrap",background:"#f1f1f1", marginTop:"10px"}}
        >
          <div
            className="circlekK"
            
          >
            <div className="circlekInnK">
             <ImageFallFB
                itemOuter={{}}
                boxShadow={``}
                src={getYouTubeThumbnail(itemInner?.youtubeLink)?.maxResolution}
                border={``}
                width={
                  100
                }
                aspectRatio={1 / 1}
                borderRadius={
                 {title:"SlideShow Image Radius",topLeft:{title:"Text Box Radius",value:10,resolution:"px"},
     topRight:{title:"Text Box Radius",value:10,resolution:"px"},
    bottomLeft:{title:"Text Box Radius",value:10,resolution:"px"},
    bottomRight:{title:"Text Box Radius",value:10,resolution:"px"}}
                }
              />
            </div>
          </div><h3>{itemInner?.youtubeLinkTitle}</h3>
        </div>
      );
    }):""}
</div>
 </div>
       </>:""}
</>)
}
export default CourseCard1PopUp;